<template>
  <v-app  >
    <v-layout  fill-height >
        <!-- ACTIVITY --> 
        <SP v-if="showSp"/>
        <MainActivity :app="null" v-else/> 
    </v-layout>
  </v-app>
</template>

<script> 
  let pageName = "App";
  import MainActivity from './views/MainActivity/activityA'
  import SP from './views/MainActivity/sp'
  export default {
    name: pageName,
    components:{
      MainActivity,
      SP
    },
    data: () => ({
      //menu
      showSp:true,
      navOpen:false,
      mini: false,
      startTime: false,
      
    }),
    created(){  
      let self = this
      setTimeout(()=>{
          // self.startTime=true
      }, 2500); 
          
    },
    mounted(){  
      let self = this  
      document.onreadystatechange = ()=>{
        if (document.readyState == "complete") { 
            if (self.startTime===true) {
              self.startApp(2500) 
            } else { 
              self.startApp(5000)        
            } 
        }else{ 
        }  
      }
    },
    computed: { 
    },
    methods: { 
      startApp(t){
        var self=this
        setTimeout(()=>{
            self.showSp=false
        },t); 
      }, 
    },
  };
</script>
